import CoreBase from '../../../services/engines/CoreBase';
import responseHelper from '../../../services/ResponseHelper';
import journalService from '../../../services/JournalService';
import umlPkgLibEngine from './UmlPkgLibEngine';
import UmlPkgLibBuilder from './UmlPkgLibBuilder.js';
import { OpenToast } from '@/JxControls/index';

/**
 * Saves a package template into a journal note.
 *  */
class UmlPkgLibSaver extends CoreBase {
    /**
     * @param {object} body - {package, satellites, connectors}, from UmlPkgLibBuilder.build
     * @param {{name: string, remarks?: string}} meta
     * @returns {Promise<object|null>}
     */
    save = async (body, meta = {}) => {
        try {
            const note = {
                rk: null,
                uid: this.getUid(),
                title: meta.name ?? '',
                service: 'Jerny.UmlWorkspace',
                type: 'UmlPkgLib',
                format: 'package-template',
                remark: meta.remarks ?? '',
                stateId: 0,
                body: JSON.stringify(body),
            };

            const dto = { data: note };
            const resp = await journalService.createOrUpdate(dto);
            if (responseHelper.check(resp, '', 'UmlPkgLibSaver.save') < 0) {
                this.logError('save', `code: ${resp?.status}`);
                return null;
            }

            // update cache direct
            umlPkgLibEngine.upsert({ ...note, rk: resp.data?.rk ?? note.rk });

            return resp.data;
        } catch (error) {
            this.logError('save', error.message);
            return null;
        }
    };

    /**
     * Builds a package template from the given live package shape (UmlPkgLibBuilder.build),
     * merges in the preview PNG (previewPng key, alongside package/satellites/connectors —
     * one note, no separate preview note), and saves it via this.save — toast on success.
     * @param {object} packageShape - the selected UmlPackageShape (live instance)
     * @param {object[]} allShapes - umlCanvasEngine.shapes
     * @param {object[]} allConnectors - umlConnectorEngine.connectors
     * @param {{name: string, remarks?: string}} meta
     * @param {string|null} [previewDataUrl] - PNG dataUrl from UmlPkgLibPreviewBuilder.build
     * @returns {Promise<object|null>}
     */
    saveTo = async (packageShape, allShapes, allConnectors, meta, previewDataUrl = null) => {
        const template = UmlPkgLibBuilder.build(packageShape, allShapes, allConnectors);
        const body = { ...template, previewPng: previewDataUrl };
        const saved = await this.save(body, meta);
        if (saved) {
            OpenToast(`Package "${meta.name}" saved to library`, undefined, { className: 'jx-toast-accent' });
        }
        return saved;
    };
}

const umlPkgLibSaver = new UmlPkgLibSaver();
export default umlPkgLibSaver;
